import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';

 
@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
  parse(value: string): any {
    if (value) {
      const dateParts = value.trim().split('/');
      if (dateParts.length === 1 && dateParts[0]) {
        return {day: Number(dateParts[0]), month: null, year: null};
      } else if (dateParts.length === 2 && dateParts[0] && dateParts[1]) {
        return {day: Number(dateParts[0]), month: Number(dateParts[1]), year: null};
      } else if (dateParts.length === 3 && dateParts[0] && dateParts[1] && dateParts[2]) {
        return {day: Number(dateParts[0]), month: Number(dateParts[1]), year: Number(dateParts[2])};
      }
    }
    return null;
  }
 
  format(date: NgbDateStruct): string {
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return date ?
        `${months[date.month-1]} ${date.day < 10 ? '0' + date.day : date.day}, ${date.year}` :
        '';
  }
}
